<template>
  <slot />
</template>

<script setup lang="ts">
import { useBuybackErrorBoundary } from '~/scopes/buyback/composables/useBuybackErrorBoundary'

useBuybackErrorBoundary()
</script>
